// extracted by mini-css-extract-plugin
module.exports = {"load-coupons-modal":"coupons_load-coupons-modal__2iBgo"};